<template>
    <div class="footer">
            <i class="far fa-copyright"></i> 
            {{ new Date().getFullYear() }}
            Henrik Davidsen. All rights reserved.
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
.footer {
   background: rgb(55, 75, 117);
   height: 40px;
   padding: 9px;
   color: rgba(255, 255, 255, 0.8);
}
</style>